import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import EditorialMarquee from "@/components/EditorialMarquee";
import AboutFounder from "@/components/AboutFounder";
import StudioPrinciples from "@/components/StudioPrinciples";
import PortfolioGallery from "@/components/PortfolioGallery";
import ContactSection from "@/components/ContactSection";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminPage from "@/pages/AdminPage";

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <KineticHero />
      <EditorialMarquee />
      <AboutFounder />
      <StudioPrinciples />
      <PortfolioGallery />
      <ContactSection />
    </main>
    <WhatsAppButton />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App" data-testid="sai-studio-app">
        <div className="grain-overlay" />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </BrowserRouter>
  );
}

export default App;
